<template>
    <b-container fluid>
        <b-row align-h="center">
            <b-col cols="12" md="8" lg="6">
                <b-card>
                    <app-client-banner v-if="isReseller"></app-client-banner>
                    <app-vecindapp-banner v-else />
                    <b-row align-h="center" class="m-4">
                        <b-col class="text-center"> Por favor seleccione el perfil con el que desea ingresar </b-col>
                    </b-row>
                    <b-row align-h="center">
                        <b-col cols="12" md="6">
                            <b-row v-for="profile in profiles" :key="profile.id" class="mb-3">
                                <b-col>
                                    <b-btn variant="primary" block @click="onProfileSelected(profile)">{{ profile.name }}</b-btn>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <app-vecindapp-banner-footer size="sm" v-if="isReseller && currentClient"></app-vecindapp-banner-footer>
                </b-card>
            </b-col>
        </b-row>
        <app-system-messages-window :systemMessages="systemMessages" @open-notices-modal="openSystemMessagesWindow"></app-system-messages-window>
    </b-container>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import * as actions from '@store/_actions'
import * as mutations from '@store/_mutations'
import appClientBanner from '@layout/ClientBanner'
import appVecindappBannerFooter from '@layout/VecindappBannerFooter'
import appSystemMessagesWindow from '@pages/communications/systemMessages/SystemMessagesWindow'
export default {
    components: {
        appClientBanner,
        appVecindappBannerFooter,
        appSystemMessagesWindow,
    },
    data: () => ({
        systemMessages: [],
    }),
    computed: {
        ...mapGetters(['capabilities']),
        profiles() {
            return _.uniqBy(this.currentUser.profiles, (item) => item.id)
        },
    },
    methods: {
        ...mapActions({
            setCurrentProfile: actions.SET_CURRENT_PROFILE,
        }),
        ...mapMutations({
            setCurrentClient: mutations.SET_CURRENT_CLIENT,
            setCapabilities: mutations.SET_CAPABILITIES,
        }),
        onProfileSelected(profile) {
            let menu_items = [...(profile?.menu_items ?? []), ...(this.currentUser?.client_position?.menu_items ?? [])]
            menu_items = menu_items.map((item) => ({ ...item, menu_key: `${item.name}-${item.menu_id}` }))
            menu_items = _.uniqBy(menu_items, (item) => item.menu_key)
            this.setCurrentProfile({ ...profile, menu_items })
            this.loadProfileCapabilities(profile)
            this.logProfileUsed(profile.id)
            this.loadSystemMessages(profile)
        },

        async loadProfileCapabilities(profile) {
            const {
                data: { capabilities },
            } = await this.$repo.get(`users/${this.currentUser.id}/capabilities`, { profileId: profile.id })

            const caps = Array.from(new Set(capabilities))
            this.setCapabilities(caps)
        },
        async logProfileUsed(profileId) {
            const { data } = await this.$repo.post(`users/${this.currentUser.id}/used-profiles`, { profileId })
        },
        async loadSystemMessages(profile) {
            const { data } = await this.$repo.get('system-messages', { pending: 1, profileId: profile.id, userId: this.currentUser.id })
            if (data.length > 0) {
                this.systemMessages = data
                this.$emit('open-notices-modal')
            } else this.$router.push({ name: profile.login_page })
        },
        openSystemMessagesWindow() {
            //
        },
    },
    created() {
        if (this.profiles.length === 1) {
            this.onProfileSelected(this.profiles[0])
        }
    },
}
</script>
